module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_date":"Edit date","select_type_date":"Select {type} date"},"id":{"edit_date":"Mengubah tanggal","select_type_date":"Pilih {type} tanggal"}}')
  delete Component.options._Ctor
}
